import { CERTIFICATEyt_ACTION_TYPES } from '../constants'

export const certificatesReducer = (state, { type, payload }) => {
  switch (type) {
    case CERTIFICATEyt_ACTION_TYPES.SET_COMPANY:
      return {
        ...state,
        company: payload,
        formState: payload,
        loadingCompany: false,
        error: {},
      }
    case CERTIFICATEyt_ACTION_TYPES.SET_LOADING:
      return {
        ...state,
        loadingCompany: payload,
      }
    case CERTIFICATEyt_ACTION_TYPES.SET_FAILURE:
      return {
        ...state,
        error: payload,
        loadingCompany: false,
        savingCompany: false,
      }
    case CERTIFICATEyt_ACTION_TYPES.CHANGE_FORM_STATE:
      return {
        ...state,
        formState: {
          ...state.formState,
          [payload.key]: payload.value,
        },
        error: {},
      }
    case CERTIFICATEyt_ACTION_TYPES.SET_FORM_STATE_SAVED:
      return {
        ...state,
        formStateSaved: payload,
      }
    case CERTIFICATEyt_ACTION_TYPES.SET_SAVING:
      return {
        ...state,
        savingCompany: payload,
      }
    case CERTIFICATEyt_ACTION_TYPES.COMPANY_SET_CHECK_OP:
      return {
        ...state,
        formState: {
          ...state.formState,
          checks_op: [
            ...state.formState.checks_op.map((singleCheck) => {
              if (singleCheck.comunidad_id === payload) {
                return { ...singleCheck, checked: true }
              } else {
                return singleCheck
              }
            }),
          ],
        },
      }
    default:
      throw new Error('unknown action')
  }
}
